import styled from 'styled-components';

export const IconButton = styled.button<{
  variant?: 'default' | 'primary' | 'danger';
  size?: 'sm' | 'md' | 'lg';
}>`
  ${({ size = 'md' }) => {
    const sizeMap = {
      sm: { width: '32px', height: '32px' },
      md: { width: '40px', height: '40px' },
      lg: { width: '48px', height: '48px' },
    };
    return `
      width: ${sizeMap[size].width};
      height: ${sizeMap[size].height};
    `;
  }}

  border-radius: ${({ theme }) => theme.borderRadius.round};
  border: none;
  background: transparent;
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  color: ${({ theme }) => theme.colors.text.secondary};
  transition: all 0.2s;

  &:hover:not(:disabled) {
    background: ${({ variant, theme }) => {
      if (variant === 'primary') return theme.colors.backgroundAccent;
      if (variant === 'danger') return `${theme.colors.status.error}10`;
      return theme.colors.backgroundSecondary;
    }};
    color: ${({ variant, theme }) => {
      if (variant === 'primary') return theme.colors.primary;
      if (variant === 'danger') return theme.colors.status.error;
      return theme.colors.text.primary;
    }};
  }

  &:active:not(:disabled) {
    transform: scale(0.95);
  }

  &:disabled {
    opacity: 0.5;
    cursor: not-allowed;
  }
`;
